import Vue from 'vue'
import Router from 'vue-router'
import Default from './layouts/default.vue'
import NoResult from './components/404.vue'
import siteType from "./configs/siteType"

Vue.use(Router)

const router = new Router({
  base: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? '/club' : "/",
  mode: 'history',
  routes: [
    {
      path: '/registerEmail',
      component: Default,
      children: [
        {
          path: '',
          name: 'registerEmail',
          component: () => import('./views/emailVerification.vue'),
          keepAlive: false
        }
      ]
    },
    // club页面的 mitid 验证后跳转回来的链接
    {
      path: '/mitid/mitCallback',
      component: Default,
      children: [
        {
          path: '',
          name: 'mitCallback',
          component: () => import('./views/mit/mitCallback.vue'),
          keepAlive: false
        }
      ]
    },
    // 客户端的 mitid 验证后跳转回来的链接
    {
      path: '/mitid/returntoapp',
      component: Default,
      children: [
        {
          path: '',
          name: 'ClientMitCallback',
          component: () => import('./views/mit/clientMitCallback.vue'),
          keepAlive: false
        }
      ]
    },

    {
      path: '/pokerland/:invitecode',
      name: 'pokerland',
      component: () => import('./views/pokerland/landing.vue'),
      keepAlive: false
    },
    {
      path: '/emailStatus',
      component: Default,
      children: [
        {
          path: '/verified',
          name: 'verified',
          component: () => import('./views/emailStatus/verified.vue'),
        },
        {
          path: '/transition/verify_email',
          name: 'tansition',
          component: () => import('./views/emailStatus/transition.vue'),
        },
        {
          path: '/failed',
          name: 'failed',
          component: () => import('./views/emailStatus/failed.vue'),
        }
      ]
    },
    {
      path: '/',
      component: Default,
      children: [
        { path: '', name: 'register', component: () => import('./views/register.vue'), keepAlive: false },
        { path: ':invitecode', name: 'register_invitecode', component: () => import('./views/register.vue'), keepAlive: false }
      ]
    },
    {
      path: '*',
      name: 'NoResult',
      component: NoResult
    }
  ]
})

export default router
